import { canv } from '@/canv/global.js'
import { elementBase } from '@/elementBase/elementBase.js'
import { textWidget } from '@/elements/text/text.js'
import { widgetOption } from '@/widgetMenu/widgetMenu';
import {
    drawRoundedRect,
    isOverRect,
    getNumberProperty,
    getStringProperty,
} from '@/canv/utils.js';

import { cardWidgetStatusBar } from '@/elements/card/statusBar/statusBar.js';
import { cardWidgetSlider } from '@/elements/card/slider/slider.js';


export class cardWidget extends elementBase {

    constructor(startX, startY) {
        super();

        this.startX = startX;
        this.startY = startY;

        // statusBar
        this.statusBar = new cardWidgetStatusBar(startX, startY);

        // slider
        this.slider = new cardWidgetSlider(startX, startY, this.width);

        // Title
        this.textTitle = new textWidget(0, 0);
        this.textTitle.menuTextSize(28, true);
        this.textTitle.shapeMode = true;
        this.textTitle.setKeepMinWidth(false);
        this.textTitle.setGreyText("Введите название");

        // author and date
        this.textAuthor = new textWidget(0, 0);
        this.textAuthor.menuTextSize(18, true);
        this.textAuthor.shapeMode = true;
        this.textAuthor.setKeepMinWidth(false);
        this.textAuthor.setGreyText("Автор задачи");
        this.textAuthor.setText(canv.getInitDataProp("userName"));
        this.textAuthor.menuTextColor("#9c9c9c");

        // description
        this.textDescription = new textWidget(0, 0);
        this.textDescription.menuTextColor("#545454", true, false);
        this.textDescription.menuTextSize(25, true);
        this.textDescription.shapeMode = true;
        this.textDescription.setKeepMinWidth(false);
        this.textDescription.setGreyText("Расскажите о прогрессе");

        this.setProgress(this.progressData["todo"]["defaultValue"]);

        this.nothingWhenInteraction = true;
        this.customResize = true;
        this.disableOutline = true;
        this.allowSideResize = true;

        this.updateDims();
    }


    // UpdateDims


    updateDims() {

        let horizontalPadding = 23;
        let verticalPadding = 18;

        // положение statusBar
        this.statusBar.updateCoords(this.startX + horizontalPadding, this.startY + verticalPadding);

        // положение title
        this.textTitle.hardWidth = this.width - 2 * horizontalPadding;
        this.textTitle.Fit();
        this.textTitle.startX = this.startX + horizontalPadding;
        this.textTitle.startY = this.statusBar.startY + this.statusBar.height + verticalPadding + this.textTitle.lines[0].textHeight;
        this.textTitle.updateDims();

        // положение slider
        this.slider.updateDims(this.startX + horizontalPadding, this.textTitle.startY + this.textTitle.height - this.textTitle.lines[0].textHeight + verticalPadding, this.width - 2 * horizontalPadding);

        // положение authorAndDate
        this.textAuthor.hardWidth = this.width - 2 * horizontalPadding;
        this.textAuthor.Fit();
        this.textAuthor.startX = this.startX + horizontalPadding;
        this.textAuthor.startY = this.slider.startY + this.slider.height + verticalPadding + this.textAuthor.lines[0].textHeight;
        this.textAuthor.updateDims();

        // положение description
        this.textDescription.hardWidth = this.width - 2 * horizontalPadding;
        this.textDescription.Fit();
        this.textDescription.startX = this.startX + horizontalPadding;
        this.textDescription.startY = this.textAuthor.startY + this.textAuthor.height - this.textAuthor.lines[0].textHeight + verticalPadding + this.textDescription.lines[0].textHeight;
        this.textDescription.updateDims();

        if (this.viewMode == "expanded") {
            this.height = this.textDescription.startY + this.textDescription.height - this.textDescription.lines[0].textHeight + verticalPadding - this.startY;
        } else {
            this.height = this.textAuthor.startY + this.textAuthor.height - this.textAuthor.lines[0].textHeight + verticalPadding - this.startY;
        }

        // проверяем минимальный width
        let minimumWidth = horizontalPadding + this.statusBar.width + horizontalPadding + this.getArrowProps()["boxWidth"] + horizontalPadding; // тут последний horizontalPadding не очень корректен. При отрисовке используется другой.
        if (this.width < minimumWidth) {
            this.width = minimumWidth;
        }

        this.updateBase(this.startX, this.startY, this.width, this.height);
    }


    // TryAction

    TryAction(type) {

        if (this.interactionType == "titleFocus") {
            this.textTitle.TryAction(type);
            this.updateDims();

            if (type == "keyboardDown") {
                this.tryShortcut();
            } else if (type == "mousedown" && !this.textTitle.isOver()) {
                this.stopInteraction();
                canv.toolBox.TryGetToolByName("cursorTool").turnMode("");
                canv.toolBox.TryGetToolByName("cursorTool").TryAction("mousedown");
            }
        } else if (this.interactionType == "descriptionFocus") {
            this.textDescription.TryAction(type);
            this.updateDims();
            if (type == "keyboardDown") {
                this.tryShortcut();
            } else if (type == "mousedown" && !this.textDescription.isOver()) {
                this.stopInteraction();
                canv.toolBox.TryGetToolByName("cursorTool").turnMode("");
                canv.toolBox.TryGetToolByName("cursorTool").TryAction("mousedown");
            }
        } if (this.interactionType == "authorFocus") {
            this.textAuthor.TryAction(type);
            this.updateDims();

            if (type == "keyboardDown") {
                this.tryShortcut();
            } else if (type == "mousedown" && !this.textAuthor.isOver()) {
                this.stopInteraction();
                canv.toolBox.TryGetToolByName("cursorTool").turnMode("");
                canv.toolBox.TryGetToolByName("cursorTool").TryAction("mousedown");
            }
        } else if (this.interactionType == "slider") {
            if (type == "mousemove") {
                let newProgress = this.slider.calculateProgress();
                this.setProgress(newProgress);
            } else if (type == "mouseup") {
                this.stopInteraction();
                canv.toolBox.TryGetToolByName("cursorTool").turnMode("");
            }
        }

    }


    // Becoming

    isInteraction(context, force = false) {

        if (context == "focus" || context == "" && force) {
            if (force || this.isTitleFocus()) {
                this.fixState("titleFocus");
                this.interactionType = "titleFocus";
                this.textTitle.focusText();
                return { "type": "interaction" };
            } else if (this.isDescriptionFocus()) {
                this.fixState("descriptionFocus");
                this.interactionType = "descriptionFocus";
                this.textDescription.focusText();
                return { "type": "interaction" };
            } else if (this.isAuthorFocus()) {
                this.fixState("authorFocus");
                this.interactionType = "authorFocus";
                this.textAuthor.focusText();
                this.textAuthor.selection.selectAll();
                return { "type": "interaction" };
            }
        } else if (context == "click") {
            if (this.isStatusAction()) { // делает действие внутри isStatusAction
                return { "type": "click" };
            } else if (this.isSliderAction()) {
                this.fixState("progress");
                this.interactionType = "slider";
                return { "type": "interaction" };
            } else if (this.isOverArrow()) {
                this.fixState("viewMode");
                if (this.viewMode == "expanded") {
                    this.viewMode = "default";
                } else {
                    this.viewMode = "expanded";
                }
                canv.eventManager.openRecord();
                this.saveState("viewMode");
                canv.eventManager.closeRecord();
                this.updateDims();
                return { "type": "click" };
            }
        } else if (context === "insertText" || context === 'pastText') {
            this.fixState("titleFocus");
            this.interactionType = "titleFocus";
            if (canv.keyboard.isEnter()) {
                this.fixState("titleFocus");
                this.interactionType = "titleFocus";
                this.textTitle.focusTextByEnter();
            } else if (!canv.keyboard.isEnter()) {
                this.fixState("titleFocus");
                this.interactionType = "titleFocus";
                this.textTitle.focusText();
                this.textTitle.selection.selectAll();
                this.textTitle.processDelete();
                this.TryAction("keyboardDown");
            }
            this.updateDims();
            return {
                "type": "interaction",
            }
        }

        return { "type": "none" };
    }

    stopInteraction() {
        if (this.interactionType == "titleFocus") {
            this.textTitle.unfocusText();
            canv.eventManager.openRecord();
            this.saveState("titleFocus");
            canv.eventManager.closeRecord();
        } else if (this.interactionType == "descriptionFocus") {
            this.textDescription.unfocusText();
            canv.eventManager.openRecord();
            this.saveState("descriptionFocus");
            canv.eventManager.closeRecord();
        } else if (this.interactionType == "authorFocus") {
            this.textAuthor.unfocusText();
            canv.eventManager.openRecord();
            this.saveState("authorFocus");
            canv.eventManager.closeRecord();
        } else if (this.interactionType == "slider") {
            canv.eventManager.openRecord();
            this.saveState("progress");
            canv.eventManager.closeRecord();
        }


        this.interactionType = "";
    }

    tryShortcut() {
        if (canv.keyboard.isEscCommand()) {
            this.stopInteraction();
            canv.toolBox.TryGetToolByName("cursorTool").turnMode("");
        }
    }







    // Draw
    draw() {
        drawRoundedRect(this.startX, this.startY, this.width, this.height, 15);
        canv.ctx.fillStyle = "#FFFFFF";
        canv.ctx.strokeStyle = this.getProgressData()["minorColor"];
        canv.ctx.lineWidth = 8;
        canv.ctx.stroke();
        canv.ctx.fill();

        canv.ctx.shadowBlur = 0;


        // statusBar
        this.statusBar.draw();
        // arrow
        this.drawArrow();
        // title
        this.textTitle.draw();

        // slider -------------------
        let isOnlySelected = canv.canvasController.selected.length == 1 && canv.canvasController.isInSelected(this.parent) && !canv.toolBox.TryGetToolByName("cursorTool").isMode("fastDragging");
        let drawCatcher = this.slider.isOverSliderCatcher() || this.interactionType == "slider" || isOnlySelected;
        let selectCatcher = this.interactionType == "slider";
        this.slider.draw(drawCatcher, selectCatcher);
        // -------------

        // --------------------

        // textAuthor
        this.textAuthor.draw();

        if (this.viewMode == "expanded") {
            this.textDescription.draw();
        }

        this.drawOutline();
    }

    drawArrow() {

        let boxStartX = this.getArrowProps()["boxStartX"];
        let boxStartY = this.getArrowProps()["boxStartY"];
        let boxWidth = this.getArrowProps()["boxWidth"];
        let boxHeight = this.getArrowProps()["boxHeight"];

        let arrowWidth = this.getArrowProps()["arrowWidth"];
        let arrowHeight = this.getArrowProps()["arrowHeight"];

        if (this.viewMode == "default" && !this.textDescription.isOnlyEmptyLine()) {
            drawRoundedRect(boxStartX, boxStartY, boxWidth, boxHeight, boxWidth * 10);
            canv.ctx.fillStyle = "#BCE3FF";

            if (this.isOverArrow()) {
                canv.ctx.fillStyle = "#A5DAFF";
            }
            canv.ctx.fill();
        } else if (this.isOverArrow()) {
            drawRoundedRect(boxStartX, boxStartY, boxWidth, boxHeight, boxWidth * 10);
            canv.ctx.fillStyle = "#F9F9F9";
            canv.ctx.fill();
        }

        if (this.viewMode == "default") {
            canv.ctx.beginPath();
            canv.ctx.moveTo(boxStartX + boxWidth / 2 - arrowWidth / 2, boxStartY + boxHeight / 2 - arrowHeight / 2);
            canv.ctx.lineTo(boxStartX + boxWidth / 2, boxStartY + boxHeight / 2 + arrowHeight / 2);
            canv.ctx.lineTo(boxStartX + boxWidth / 2 + arrowWidth / 2, boxStartY + boxHeight / 2 - arrowHeight / 2);
        } else {
            canv.ctx.beginPath();
            canv.ctx.moveTo(boxStartX + boxWidth / 2 - arrowWidth / 2, boxStartY + boxHeight / 2 + arrowHeight / 2);
            canv.ctx.lineTo(boxStartX + boxWidth / 2, boxStartY + boxHeight / 2 - arrowHeight / 2);
            canv.ctx.lineTo(boxStartX + boxWidth / 2 + arrowWidth / 2, boxStartY + boxHeight / 2 + arrowHeight / 2);
        }


        canv.ctx.lineCap = "round";
        canv.ctx.lineWidth = 2;
        canv.ctx.strokeStyle = "#000000";
        canv.ctx.stroke();

        canv.ctx.closePath();


    }

    drawOutline() {
        // рисуем outline сами, чтобы сделать его закругленным

        let shouldDraw = canv.canvasController.isInSelectedDeep(this.parent) && !canv.toolBox.TryGetToolByName("cursorTool").isMode("fastDragging");

        if (!shouldDraw) return;

        drawRoundedRect(this.startX, this.startY, this.width, this.height, 15);
        if (this.interactionType == "") {
            canv.ctx.strokeStyle = "#0B99FF";
        } else {
            canv.ctx.strokeStyle = "#BCE3FF";
        }
        canv.ctx.lineWidth = canv.actionManager.getZoomConstant(2.5);
        canv.ctx.stroke();
    }




    // translate, resize


    translate(x, y) {
        this.startX += x;
        this.startY += y;
        this.updateDims();
    }

    resize(x, y, catchPointer) {
        if (catchPointer == "sideRight" || catchPointer == "sideLeft") {
            this.width += x;
        }
        this.updateDims();
    }




    // helpers

    isStatusAction() {

        if (this.statusBar.isStatusClick()) {
            let data = this.getProgressData();

            let newStatus = "todo";
            if (data["name"] == "todo") {
                newStatus = "progress";
            } else if (data["name"] == "progress") {
                newStatus = "done";
            } else if (data["name"] == "done") {
                newStatus = "todo";
            }

            canv.eventManager.openRecord();
            this.fixState("progress");
            this.setProgress(this.progressData[newStatus]["defaultValue"]);
            this.saveState("progress");
            canv.eventManager.closeRecord();
            return true;
        } else if (this.statusBar.isCheckboxClick()) {
            canv.eventManager.openRecord();
            this.fixState("progress");

            if (this.getProgressData()["name"] == "done") {
                this.setProgress(this.progressData["progress"]["defaultValue"]);
            } else {
                this.setProgress(this.progressData["done"]["defaultValue"]);
            }

            this.saveState("progress");
            canv.eventManager.closeRecord();
            return true;
        }
    }

    isTitleFocus() {
        if (this.textTitle.isOver()) {
            return true;
        }
        return false;
    }

    isDescriptionFocus() {
        if (this.textDescription.isOver()) {
            return true;
        }
        return false;
    }

    isAuthorFocus() {
        if (this.textAuthor.isOver()) {
            return true;
        }
        return false;
    }

    isSliderAction() {
        return this.slider.isOverSliderCatcher();
    }

    isOverArrow() {
        let boxStartX = this.getArrowProps()["boxStartX"];
        let boxStartY = this.getArrowProps()["boxStartY"];
        let boxWidth = this.getArrowProps()["boxWidth"];
        let boxHeight = this.getArrowProps()["boxHeight"];

        if (isOverRect(boxStartX, boxStartY, boxWidth, boxHeight)) {
            return true;
        }

        return false;
    }

    getArrowProps() {

        let arrowWidth = 10;
        let arrowHeight = 7;

        let horizontalPadding = 30;
        let boxWidth = 33;
        let boxHeight = 33;

        let boxStartX = this.startX + this.width - horizontalPadding - boxWidth;
        let boxStartY = this.statusBar.startY + this.statusBar.height / 2 - boxHeight / 2;

        return {
            "boxStartX": boxStartX,
            "boxStartY": boxStartY,
            "boxWidth": boxWidth,
            "boxHeight": boxHeight,
            "arrowWidth": arrowWidth,
            "arrowHeight": arrowHeight,
        };
    }

    setProgress(progress) {
        this.progress = progress;
        let progressData = this.getProgressData();
        this.statusBar.setProgressData(progressData, this.interactionType !== "slider");
        this.slider.setProgressData(progressData, this.interactionType !== "slider");
    }

    getProgressData() {
        let data = null;

        if (this.progress >= this.progressData["todo"]["border"]) data = this.progressData["todo"];
        if (this.progress >= this.progressData["progress"]["border"]) data = this.progressData["progress"];
        if (this.progress >= this.progressData["done"]["border"]) data = this.progressData["done"];

        data["currentProgress"] = this.progress;

        return data;
    }

    clearText() {
        this.textTitle.clearText();
        this.textDescription.clearText();
        this.textAuthor.clearText();
        this.updateDims();
    }

    searchText(text) {
        let result = [];
        const widgets = [this.textTitle, this.textDescription, this.textAuthor];

        for (var i = 0; i < widgets.length; i++) {
            const textWidget = widgets[i].getText().toLowerCase();

            if (textWidget.includes(text)) {
                result.push({
                    "status": true,
                    "textWidget": widgets[i],
                    "mode": 'widget',
                })
            }
        }

        return result;
    }


    // Обработчики для меню



    getWidgetOptions() {
        var widgetOptions = [];

        widgetOptions.push(new widgetOption("check", this.getProgressData()["name"] == "done", this.UID));

        if (this.interactionType === "descriptionFocus") {
            this.textDescription.setAffectedItemsUniqValues(widgetOptions, "link", "link", this.UID);
            this.textDescription.setEditTextMobile(widgetOptions, this.UID);
        } else if (this.interactionType === "authorFocus") {
            this.textAuthor.setAffectedItemsUniqValues(widgetOptions, "link", "link", this.UID);
            this.textAuthor.setEditTextMobile(widgetOptions, this.UID);
        } else if (this.interactionType === "titleFocus") {
            this.textTitle.setAffectedItemsUniqValues(widgetOptions, "link", "link", this.UID);
            this.textTitle.setEditTextMobile(widgetOptions, this.UID);
        }

        return widgetOptions;
    }

    getHandlerForOption(name) {
        if (name === "check") {
            return this.menuCheck;
        } else if (name === "link") {
            return this.menuLink;
        } else if (name === "mobileEdit") {
            let textPart = this.textDescription;
            if (this.interactionType === "authorFocus") {
                textPart = this.textAuthor;
            } else if (this.interactionType === "titleFocus") {
                textPart = this.textTitle;
            }
            return () => textPart.menuMobileEdit(false);
        }
    }

    menuLink(currentLink) {
        if (this.interactionType == "titleFocus") {
            this.textTitle.menuLink(currentLink, this.updateDims.bind(this));
        } else if (this.interactionType == "descriptionFocus") {
            this.textDescription.menuLink(currentLink, this.updateDims.bind(this));
        } else if (this.interactionType == "authorFocus") {
            this.textAuthor.menuLink(currentLink, this.updateDims.bind(this));
        } else {
            canv.toolBox.TryGetToolByName("cursorTool").setSelectedAndInteraction(this.parent);
            this.textTitle.selection.selectAll();
            this.textTitle.menuLink(currentLink), this.updateDims.bind(this);
        }
    }

    menuCheck(check) {
        if (check) {
            this.setProgress(this.progressData["done"]["defaultValue"]);
        } else {
            this.setProgress(this.progressData["progress"]["defaultValue"]);
        }
    }


    // Далее для statesManager

    getFixType(reason) {
        var fixType = "full";

        switch (reason) {
            case "move":
                fixType = "move";
                break;
            case "resize":
                fixType = "resize";
                break;
            case "wm_check":
            case "progress":
                fixType = "progress";
                break;
            case "viewMode":
                fixType = "viewMode";
                break;
        }

        return fixType;
    }

    getState(fixType) {
        var state = {};

        switch (fixType) {
            case "move":
                state["startX"] = this.startX;
                state["startY"] = this.startY;
                break;
            case "resize":
                state["startX"] = this.startX;
                state["startY"] = this.startY;
                state["width"] = this.width;
                break;
            case "progress":
                state["progress"] = this.progress;
                break;
            case "viewMode":
                state["viewMode"] = this.viewMode;
                break;
            case "full":
                state["UID"] = this.UID;
                state["parentUID"] = this.parentUID;
                state["entityType"] = "cardWidget";

                state["startX"] = this.startX;
                state["startY"] = this.startY;
                state["width"] = this.width;

                state["progress"] = this.progress;
                state["viewMode"] = this.viewMode;

                state["textTitle"] = this.textTitle.getState("full");
                state["textDescription"] = this.textDescription.getState("full");
                state["textAuthor"] = this.textAuthor.getState("full");

                break;
        }

        return state;
    }

    loadState(stateObj, fixType) {

        switch (fixType) {
            case "move":
                this.startX = getNumberProperty("startX", stateObj);
                this.startY = getNumberProperty("startY", stateObj);
                break;
            case "resize":
                this.startX = getNumberProperty("startX", stateObj);
                this.startY = getNumberProperty("startY", stateObj);
                this.width = getNumberProperty("width", stateObj);
                break;
            case "progress":
                this.setProgress(getNumberProperty("progress", stateObj));
                break;
            case "viewMode":
                this.viewMode = getStringProperty("viewMode", stateObj, "default");
                break;
            case "full":
                this.UID = getStringProperty("UID", stateObj);
                this.parentUID = getStringProperty("parentUID", stateObj);

                this.startX = getNumberProperty("startX", stateObj);
                this.startY = getNumberProperty("startY", stateObj);
                this.width = getNumberProperty("width", stateObj);

                this.setProgress(getNumberProperty("progress", stateObj));
                this.viewMode = getStringProperty("viewMode", stateObj, "default");

                this.textTitle.loadState(stateObj["textTitle"], "full");
                this.textDescription.loadState(stateObj["textDescription"], "full");
                this.textAuthor.loadState(stateObj["textAuthor"], "full");

                break;
        }

        this.updateDims();
    }


    constructorName = "card";
    startX = 0;
    startY = 0;
    width = 450;
    height = 220;

    interactionType = "";

    statusBar = null;
    textTitle = null;
    textAuthor = null;
    textDescription = null;

    viewMode = "default";


    progress = 0;
    progressData = {
        "todo": {
            "name": "todo",
            "border": 0,
            "defaultValue": 0.09,
            "title": "В плане",
            "minorColor": "#ECECEC",
            "majorColor": "#5B5B5B",
        },
        "progress": {
            "name": "progress",
            "border": 0.1,
            "defaultValue": 0.5,
            "title": "В работе",
            "minorColor": "#F9E8C7",
            "majorColor": "#DE9A19",
        },
        "done": {
            "name": "done",
            "border": 0.8,
            "defaultValue": 1,
            "title": "Готово",
            "minorColor": "#D4EBC3",
            "majorColor": "#55A718",
        }
    }
}
